import { useEffect, useState } from "react";
import { KeywordsTransport } from "src/app/transports/keywords";
import { Keyword } from "src/app/types/keywords";

const useGetKeywordData = (id?: number) => {
    const [keywordData, setKeywordData] = useState<Keyword>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();

    useEffect(() => {
        KeywordsTransport.find(id)
            .then((res) => {
                setKeywordData(res);
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    }, []);

    return { keywordData, loading, error };
};

export default useGetKeywordData;
